import LocalControls from './local-controls';

export default LocalControls;
